import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Spinner, Button } from "react-bootstrap";
import MonthlyCalendar from "./MontlyCalender";
import { useSelector } from "react-redux";
import useGetAllManagers from "../Common/ReuseApi/useGetAllManagers";

const Compliance = ({ employees }) => {
  const userState = useSelector((state) => state.loginData.userData);
  console.log("userstate123", userState)

  const roleOfUser = ["teamlead", "manager"]

  const [loader, setLoader] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [employeeId, setEmployeeId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  useEffect(() => {
    getCompliance();
  }, [month, year, employeeId]);

  const getCompliance = async () => {
    setLoader(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BASE_URL + "/task/get/alltask/compailance",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userState?.token}`,
          },
          body: JSON.stringify({
            // empId: employeeId || userState.empId,
            // empId: userState.resourceType === "humanResource" ? "humanResource" :
            //   (userState.resourceType === "manager" && userState.resourceType === "teamlead") ? userState.assignedEmployee : employeeId || userState.empId,
            empId: employeeId && employeeId.toLowerCase() === "all" ? "all" : employeeId || userState.empId,
            assignedEmployee: userState.assignedEmployee,
            resourceType: userState.resourceType,
            month: month,
            year: year,
            proposedStartDate: fromDate,
            proposedEndDate: toDate,
          }),
        }
      );

      const res = await response.json();
      if (res.status === 200) {
        setTasks(res.data);
      }
    } catch (Err) {
      console.log("Error while compliance =>", Err);
    } finally {
      setLoader(false);
    }
  };

  const handleLeaveApplied = () => {
    getCompliance();
  };

  // for excel export 
  const handleExportExcel = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BASE_URL + "/task/get/alltask/getAllTaskCompailanceExcel",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userState?.token}`,
          },
          body: JSON.stringify({
            empId: employeeId && employeeId.toLowerCase() === "all" ? "all" : employeeId || userState.empId,
            assignedEmployee: userState.assignedEmployee,
            resourceType: userState.resourceType,
            month: Number(month),
            year: Number(year),
            proposedStartDate: fromDate || "",
            proposedEndDate: toDate || "",
          }),
        }
      );

      const res = await response.json();

      if (res?.status === 200 && res?.excelUrl) {
        window.open(res.excelUrl, "_blank");
      } else {
        alert("Excel export failed");
      }
    } catch (error) {
      console.log("Export error:", error);
      alert("Something went wrong while exporting excel");
    }
  };

  const { data: allManagerOptions } = useGetAllManagers({
    resourceType: userState?.resourceType
  }, [userState?.resourceType]);

  return (
    <Container className="outletPadding">
      {userState.resourceType !== "employee" && (
        <Row className="mb-3 justify-content-end align-items-end">

          <Col xs={12} md={3}>
            <Form.Label>Select employee</Form.Label>
            <Form.Select
              value={employeeId || ""}
              onChange={(e) => {
                setTasks([]);
                setEmployeeId(e.target.value);
              }}
            >
              {/* <option value="">Select Employee</option> */}
              <option value="all">All</option>

              {userState?.resourceType === "humanResource"
                ? allManagerOptions.map((emp) => (
                  <option key={emp.value} value={emp.value}>
                    {emp.label}
                  </option>
                ))
                : employees.map((emp) => (
                  <option key={emp.value} value={emp.value}>
                    {emp.label}
                  </option>
                ))
              }
              {/* <option value="">Select Employee</option>
              {employees.map((emp) => (
                <option key={emp.value} value={emp.value}>
                  {emp.label}
                </option> */}
              {/* <option value="">Select Employee</option>
              <option value="all">All</option>
              {employees.map((emp) => (
                <option key={emp.value} value={emp.value}>
                  {emp.label}
                </option>
              ))} */}
            </Form.Select>
          </Col>

          <Col xs="auto" className="d-flex align-items-end">
            <Button className="activeBtn" onClick={handleExportExcel}>
              Export Excel
            </Button>
          </Col>

        </Row>
      )}

      {/* Filters for Month and Year */}
      <Row className="my-5 align-items-end">
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12} md={4}>
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                value={fromDate || ""}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Col>

            <Col xs={12} md={4}>
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                value={toDate || ""}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Col>

            <Col xs={12} md={4} className="d-flex align-items-end">
              <Button
                className="primaryBtn "
                onClick={() => {
                  getCompliance();
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Col>

        <Col xs={12} md={6} className="d-flex justify-content-end gap-2 mt-3 mt-md-0">
          <Form.Select
            style={{ width: "150px" }}
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          >
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {new Date(0, i).toLocaleString("default", { month: "long" })}
              </option>
            ))}
          </Form.Select>

          <Form.Select
            style={{ width: "120px" }}
            value={year}
            onChange={(e) => setYear(e.target.value)}
          >
            {[...Array(2)].map((_, i) => (
              <option key={i} value={new Date().getFullYear() - i}>
                {new Date().getFullYear() - i}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>

      {/* Calendar */}
      {loader ? (
        <div className="text-center my-4">
          <Spinner size="lg" />
        </div>
      ) : (
        <MonthlyCalendar
          key={employeeId}
          year={year}
          month={month}
          tasks={tasks}
          employeeId={employeeId}
          employees={employees}
          onLeaveApplied={handleLeaveApplied}
        />
      )}
    </Container>
  );
};

export default Compliance;
